import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import { FaCalculator } from 'react-icons/fa';
import { FormationsSectionProps } from '../types/types';

const FormationsSection: React.FC<FormationsSectionProps> = ({
  formations,
  handleFormationChange
}) => {
  const CalculatorIcon: React.FC<{ className?: string }> = ({ className }) => {
    const IconComponent = FaCalculator as any;
    return <IconComponent className={className} />;
  };
  return (
    <Card className="mb-4 section">
      <Card.Header as="h2">
        <CalculatorIcon className="me-2" /> FORMATIONS
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <Card className="subsection">
              <Card.Body>
                <h3>Cap Rock</h3>
                <Form.Group className="mb-3" controlId="capRockStart">
                  <Form.Label>Starting Depth (feet)</Form.Label>
                  <Form.Control
                    type="number"
                    name="capRockStart"
                    placeholder="Enter starting depth"
                    value={formations.capRockStart}
                    onChange={handleFormationChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a starting depth.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="capRockEnd">
                  <Form.Label>Ending Depth (feet)</Form.Label>
                  <Form.Control
                    type="number"
                    name="capRockEnd"
                    placeholder="Enter ending depth"
                    value={formations.capRockEnd}
                    onChange={handleFormationChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide an ending depth.
                  </Form.Control.Feedback>
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="subsection">
              <Card.Body>
                <h3>Salt</h3>
                <Form.Group className="mb-3" controlId="saltStart">
                  <Form.Label>Starting Depth (feet)</Form.Label>
                  <Form.Control
                    type="number"
                    name="saltStart"
                    placeholder="Enter starting depth"
                    value={formations.saltStart}
                    onChange={handleFormationChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a starting depth.
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="saltEnd">
                  <Form.Label>Ending Depth (feet)</Form.Label>
                  <Form.Control
                    type="number"
                    name="saltEnd"
                    placeholder="Enter ending depth"
                    value={formations.saltEnd}
                    onChange={handleFormationChange}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide an ending depth.
                  </Form.Control.Feedback>
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FormationsSection;
